<template>
  <el-dialog
    center
    width="90%"
    top="0"
    :lock-scroll="true"
    :model-value="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :title="title"
    @closed="closeDialog"
  >
    <div v-if="isKeyenceEnterpriseBrowser" class="hardkey-absorber-layer" aria-hidden="true">
      <KeyenceHTHardKeyButton
        :hardkey="KeyenceHardKey.ENTER"
        :function="absorbModalHardKey"
        :visible="visible"
        :newLayer="true"
      />
      <KeyenceHTHardKeyButton
        :hardkey="KeyenceHardKey.BACKSPACE"
        :function="absorbModalHardKey"
        :visible="visible"
        :newLayer="false"
      />
    </div>
    <div v-html="message" class="dialogMessage"></div>
    <template #footer>
      <div class="dialog-footer flex flex-col gap-1">
        <div>
          <el-button id="AppDialog_proceedAnyway" type="primary" @click="proceedAnyway" class="full-w-button mx-0">
            {{ $t('proceedAnyway') }}
          </el-button>
        </div>
        <div>
          <el-button id="AppDialog_cancelDialog" @click="closeDialog" class="full-w-button mx-0">
            {{ $t('cancel') }}
          </el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import KeyenceHTHardKeyButton from '@/components/keyenceHT/hardkeys/KeyenceHTHardKeyButton.vue'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { KeyenceHardKey } from '@/utils/keyenceHT/keyenceHardKeyEventHandler'
import { isKeyenceEnterpriseBrowser } from '@/utils/keyenceHT/keyenceModules'

@Options({
  components: {
    KeyenceHTHardKeyButton,
  },
  name: 'SkippingCustomValidationDialog',
  emits: ['proceed', 'close'],
})
export default class SkippingCustomValidationDialog extends Vue {
  @Prop({ default: false }) visible!: boolean
  @Prop({ default: '' }) message!: string
  @Prop({ default: 'Custom Validation Warning' }) title!: string

  KeyenceHardKey = KeyenceHardKey

  get isKeyenceEnterpriseBrowser(): boolean {
    return isKeyenceEnterpriseBrowser()
  }

  absorbModalHardKey(): void {
    // Out of scope: register layer via visible, but do not proceed or close.
  }

  closeDialog() {
    this.$emit('close')
  }

  proceedAnyway() {
    this.$emit('proceed')
  }
}
</script>

<style lang="scss" scoped>
.hardkey-absorber-layer {
  position: fixed;
  width: 0;
  height: 0;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
  z-index: -1;
}
</style>
